import 'utils/filter_form';
import 'utils/form_data_summary';
import 'utils/autofill_by_query_string';
import 'components/select';

import './index.scss';

(function ($) {
  const $filterForm = $('#js-guides-filter-form');

  $filterForm
    .filterForm()
    .formDataSummary('.js-summary')
    .autoFillByQueryString()
    .lazyReady();

  $('.js-select-all', $filterForm).on('click', (e) => {
    const $btn = $(e.target);
    const $inputs = $filterForm.find(`[data-group=${$btn.data('target-group')}]`);

    $btn.toggleClass('selected');
    $inputs
      .prop(
        'checked',
        !$inputs.toArray().every(input => $(input).is(':checked'))
      )
      .trigger('change');

  });

  $('.js-btn-group', $filterForm).each((i, elem) => {
    const $elem = $(elem);
    $elem.on('change', '.js-sel', () => {
      $elem.find('.js-select-all').toggleClass(
        'selected',
        $elem.find('.js-sel').toArray().every(input => $(input).is(':checked'))
      );
    });
  });

  $(':checked', $filterForm).trigger('change');
  $('option', $filterForm).filter(':selected').parent().trigger('change');

  $filterForm.on('submit', () => {
    $filterForm.trigger('filterFormToggle');
  });

})(jQuery);
